import { getVtxToken } from '@vtx/utils';
import { Resource } from 'cesium';

const getToken = () => {
    return getVtxToken('token');
}

export const getResource = (url, {token, params, ...options}) => {
    return new Resource({
        url,
        headers: {
            'Authorization': `Bearer ${token || getToken()}`
        },
        queryParameters: params,
        ...options
    })
}
export default getToken;
